import Resource, { Metadata } from './ResourceTyped';
import { parseDates } from 'App/resources/genericParser';
import type Notification from 'App/resources/Model/Notification.d.ts';

const DATE_FIELDS = ['date', 'read'];

type NotificationFindResponse = {
	data: Notification[];
	metadata: Metadata;
};

class NotificationResource extends Resource<Notification> {
	constructor() {
		super('notifications');
	}

	customer(customerId: number | string) {
		return {
			find: (
				filter: { [key: string]: unknown } = {},
				options: { [key: string]: unknown } = {}
			): Promise<NotificationFindResponse> =>
				this._getRequest('notifications', {
					...options,
					_url: `${customerId}`,
					methodName: 'find',
					params: { ...filter, ...options }
				}).then((res: { data: NotificationFindResponse }) => ({
					...res.data,
					data: parseDates<Notification, Notification>(res.data.data ?? [], DATE_FIELDS) as Notification[]
				}))
		};
	}
}

export default new NotificationResource();
